  <template>
    <div>
      <template v-if="organisation === 'Nhood'">
        <NhoodPageNotFound></NhoodPageNotFound>
      </template>
      <template v-else>
        <FillitPageNotFound></FillitPageNotFound>
      </template>
    </div>
</template>

<script>
import NhoodPageNotFound from "../components/themes/nhood/PageNotFound"
import FillitPageNotFound from "../components/themes/fillit/PageNotFound"


export default {
  name: 'PageNotFound',
  data: () => ({
    organisation: null
  }),
  components: {
    FillitPageNotFound,
    NhoodPageNotFound
  },
  created () {
  },
  mounted () {
    this.organisation = organisation
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
